import API from './API';
import { TParentOptions } from './TreedisPublicDAO';

/**
 * TAI API class for handling AI image processing requests
 * Uses Lambda endpoint (NEXT_PUBLIC_API_TAIDESIGN) instead of the main API
 */
class TAIAPI extends API {
  constructor() {
    // Use Lambda endpoint for TAI operations
    super({ baseUrl: process.env.NEXT_PUBLIC_API_TAIDESIGN + '/' });
    const parent = this.public;

    this.public = {
      /**
       * Process TAI image generation/editing request
       * @param options - Request options containing the image processing payload
       * @param parentOptions - Additional parent options (fingerprinting, error handling, etc.)
       * @returns Promise with the processed image response
       */
      processTAIImage: ({ ...options } = {}, parentOptions: TParentOptions = {}) =>
        parent.post({ url: '', ...options }, parentOptions),
    };
  }
}

const DAO = new TAIAPI().public;

export default DAO;
